import type { CheckoutConfiguration } from '@/types/boot';
import type { Template } from '@/types/template';
import { CheckoutTemplateToTemplatesMapping, getTemplateConfig } from '@/constants/templateConfig';
import { PaymentMethodTypeToEnum } from '@/constants/paymentMethodTypeMapping';
import type { PaymentMethodEnum } from '@/types/common';

export interface TemplateInitializationResult {
  template: Template;
  selectedPaymentMethod?: PaymentMethodEnum;
}

export const initializeTemplateFromBootConfig = (
  checkoutConfig: CheckoutConfiguration | undefined,
  currentTemplate: Template
): TemplateInitializationResult => {
  if (!checkoutConfig?.template) {
    return { template: currentTemplate };
  }

  const templateType = CheckoutTemplateToTemplatesMapping[checkoutConfig.template];

  if (!templateType) {
    return { template: currentTemplate };
  }

  const templateConfig = getTemplateConfig(
    templateType,
    checkoutConfig.availablePaymentMethods?.[0],
    currentTemplate.backgroundImageUrl
  );

  const result: TemplateInitializationResult = {
    template: templateConfig,
  };

  if (templateConfig.features.autoSelectPaymentMethod && checkoutConfig.availablePaymentMethods?.[0]) {
    const paymentMethodType = checkoutConfig.availablePaymentMethods[0];
    const selectedPaymentMethod = PaymentMethodTypeToEnum[paymentMethodType];
    if (selectedPaymentMethod) {
      result.selectedPaymentMethod = selectedPaymentMethod;
    }
  }

  return result;
};
